import { IPropertyConverter } from "ta-json";

import { JsonValue, Object_Unknown } from "../base-types";
import { InvalidOperationError } from "../errors/invalid-operation-error";

export class StringToAnyMapConverter implements IPropertyConverter {
    /**
     * Serializes an object into a JsonValue.
     *
     * @param value - An object
     *
     * @returns A Json Value.
     */
    serialize(value: Object_Unknown): JsonValue {
        return JSON.stringify(value);
    }

    /**
     * Deserializes a JsonValue into an object.
     *
     * @param value - A Json Value
     *
     * @returns An object.
     */
    deserialize(value: JsonValue): Object_Unknown {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "string") {
            throw new InvalidOperationError(
                `Expected a value of type 'string', but value was of type '${typeof value}'.`
            );
        }

        const obj: Object_Unknown = typeof value === "string" ? JSON.parse(value) : JSON.parse(JSON.stringify(value));

        return obj;
    }
}
